import React from "react";
import { Helmet } from "react-helmet-async";
import Heading from "../components/common/Heading";
import Services from "../components/home/Service";
import Sliders from "../components/home/Testimonial";
import QuickFacts from "../components/common/QuickFacts";

export default function Service() {
  return (
    <>
      <Helmet>
        <title>Services & Amenities | HariKunj Resort Jodhpur</title>
        <meta
          name="description"
          content="Experience first-class resort amenities at HariKunj. Features gourmet Rajasthani multi-cuisine dining, signature spa wellness, a royal swimming pool, and pristine party/wedding lawns."
        />
        <link rel="canonical" href="https://harikunjresort.com/services" />
        <meta property="og:title" content="Services & Amenities | HariKunj Resort Jodhpur" />
        <meta property="og:description" content="Experience first-class resort amenities at HariKunj. Features gourmet Rajasthani multi-cuisine dining, signature spa wellness, a royal swimming pool, and pristine party/wedding lawns." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://harikunjresort.com/services" />
        <meta property="og:image" content="https://harikunjresort.com/assets/img/Kaylana-Lake.webp" />
      </Helmet>

      <Heading heading="Services & Amenities" title="Home" subtitle="Services" />

      <h1 className="visually-hidden">
        Premier Resort Services, Swimming Pool, Dining &amp; Event Lawns — HariKunj Resort Jodhpur
      </h1>

      <Services />
      <Sliders />
      <QuickFacts pageTitle="Services & Amenities" />
    </>
  );
}
